@if (extension) {
  @if (header) {
    <h5>{{ header }}</h5>
  }
  <div class="detail-item">
    <a [routerLink]="['/', extensionsRoute, extension.extensionId]">
      {{ extension.number }} - {{ extension.name }}
    </a>
  </div>
}
